import { gql } from '@apollo/client';

export const SET_CREDENTIALS_CLIQUE_RETIRE = gql`
  mutation SetCliqueRetireCredentials(
    $credentials: CliqueRetireCredentialsInput!
  ) {
    setCliqueRetireCredentials(credentials: $credentials) {
      __typename
      ... on SetCliqueRetireCredentialsSuccess {
        code
        credentials {
          apiKey
          apiId
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
